// extracted by mini-css-extract-plugin
module.exports =  {"wrap":"e2ff468f85--wrap--zQ75m","tabs":"e2ff468f85--tabs--Wdhvj","wrap-left-blur":"e2ff468f85--wrap-left-blur--rD4kQ","wrap-right-blur":"e2ff468f85--wrap-right-blur--gI_XY"};